module.exports = "//public.getcloudapp.com/packs/media/images/prize@2x-2501f4e4e867be9f52084c1a3e1bc151.png";